/**
* @Author: Michael Neumair <mBook>
* @Date:   2016-08-15T17:05:24+02:00
* @Email:  7q7w7e7r@gmail.com
* @Last modified by:   mBook
* @Last modified time: 2016-09-30T17:45:03+02:00
*/


import React, {Component} from 'react';
import PropTypes from 'prop-types';
import uniqueId from 'lodash/uniqueId';
import inputProps from './../../../utilities/inputProps';

/**
 * AInputRadioSelect - a input radio which gets text as elment
**/
class AInputRadioSelect extends Component {
  constructor(props) {
    super(props);
    this._name = uniqueId();
  }

  render() {
    const {
      style,
      groupName,
      checked,
      htmlValue,
      children,
      error, // eslint-disable-line no-unused-vars
      disabled,
      visualState,
      onChange,
      onFocus,
      onBlur,
      onPress,
    } = this.props;

    const checkedClass = (checked) ? 'checked' : '';

    return (
      <div
        style={style}
        className={`a-input a-input-radio-select ${visualState} ${checkedClass}`}
        onClick={onPress}
      >
        <input
          name={groupName}
          checked={checked}
          value={htmlValue}
          className="a-input-radio-select__input"
          type="radio"
          id={this._name}
          onChange={onChange}
          onFocus={onFocus}
          onBlur={onBlur}
          disabled={disabled}
        />
        <label
          className="a-input-radio-select__label"
          htmlFor={this._name}
        >
          {children}
        </label>
      </div>
    );
  }
}
AInputRadioSelect.propTypes = {
  /**
     * html name to build groups of radios
     * @type {String}
     */
  groupName: PropTypes.string,
  error: PropTypes.bool,
  disabled: PropTypes.bool,
  /**
     * the current value/checked of the input - i it is checked
     */
  checked: PropTypes.bool,
  /**
     * the html value attribute.
     * NOTE: Don't confuse it with the checked value!
     */
  htmlValue: PropTypes.string.isRequired,
  /**
     * this will be the label
     * @type {[type]}
     */
  children: PropTypes.any,
  style: PropTypes.object,
  visualState: PropTypes.string, // passed by inputProps
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  /**
     * fires when the input has been pressed,
     * it won't fire if the input is disabled
     * @type {Function}
     */
  onPress: PropTypes.func,
};
AInputRadioSelect.defaultProps = {
  children: 'AInputRadioSelect',
};
export default inputProps(AInputRadioSelect);

